module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('view-box', {
    attrs: {
      "body-padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "body",
    staticStyle: {
      "height": "100%",
      "overflow": "auto"
    }
  }, [_c('m-column', {
    attrs: {
      "title": "投保人暨被保险人信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('x-input', {
    attrs: {
      "max": 8,
      "show-clear": false,
      "type": "text",
      "title": "投保姓名",
      "placeholder": "请输入投保姓名",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkInsuredName
    },
    model: {
      value: (_vm.insuredName),
      callback: function($$v) {
        _vm.insuredName = $$v
      },
      expression: "insuredName"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 18,
      "show-clear": false,
      "type": "text",
      "title": "身份证号",
      "placeholder": "请输入身份证号",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkInsuredIDNumber
    },
    model: {
      value: (_vm.insuredIDNumber),
      callback: function($$v) {
        _vm.insuredIDNumber = $$v
      },
      expression: "insuredIDNumber"
    }
  }), _vm._v(" "), _c('x-switch', {
    attrs: {
      "id": "IDNumber-wrap",
      "title": _vm.IDNumberTitle
    },
    on: {
      "on-change": _vm.changeIDNumberExpire
    },
    model: {
      value: (_vm.IDNumberValue),
      callback: function($$v) {
        _vm.IDNumberValue = $$v
      },
      expression: "IDNumberValue"
    }
  }), _vm._v(" "), (!_vm.IDNumberValue) ? _c('datetime', {
    ref: "IDNumberExpire",
    class: {
      active: !(_vm.IDNumberExpire === '' || _vm.IDNumberExpire === '9999-10-10')
    },
    attrs: {
      "default-selected-value": "2030-08-18",
      "max-year": 3017,
      "start-date": _vm.limitDate.startDate,
      "end-date": _vm.limitDate.endDate,
      "placeholder": "请选择身份证有效期",
      "confirm-text": "确定",
      "cancel-text": "取消",
      "title": "&nbsp;"
    },
    model: {
      value: (_vm.IDNumberExpire),
      callback: function($$v) {
        _vm.IDNumberExpire = $$v
      },
      expression: "IDNumberExpire"
    }
  }) : _vm._e(), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 11,
      "keyboard": "number",
      "show-clear": false,
      "title": "手机号码",
      "placeholder": "请输入手机号码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderPhoneNumber
    },
    model: {
      value: (_vm.holderPhoneNumber),
      callback: function($$v) {
        _vm.holderPhoneNumber = $$v
      },
      expression: "holderPhoneNumber"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 4,
      "keyboard": "number",
      "show-clear": false,
      "title": "手机验证码",
      "placeholder": "请输入手机验证码",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderCAPTCHA
    },
    model: {
      value: (_vm.holderCAPTCHA),
      callback: function($$v) {
        _vm.holderCAPTCHA = $$v
      },
      expression: "holderCAPTCHA"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "disabled": _vm.CAPTCHACountdown === 0 ? false : true,
      "type": "primary",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.sendCAPTCHA($event)
      }
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.CAPTCHALabel))])], 1), _vm._v(" "), _c('x-input', {
    attrs: {
      "max": 50,
      "show-clear": false,
      "type": "text",
      "title": "电子邮箱",
      "placeholder": "请输入个人电子邮箱",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderEmail
    },
    model: {
      value: (_vm.holderEmail),
      callback: function($$v) {
        _vm.holderEmail = $$v
      },
      expression: "holderEmail"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "所在地区",
      "list": _vm.ChinaAddressV2Data,
      "placeholder": "请选择所在地区"
    },
    model: {
      value: (_vm.holderArea),
      callback: function($$v) {
        _vm.holderArea = $$v
      },
      expression: "holderArea"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "show-clear": false,
      "max": 50,
      "type": "text",
      "title": "详细地址",
      "placeholder": "请输入详细地址",
      "placeholder-align": "right",
      "text-align": "right"
    },
    on: {
      "on-blur": _vm.checkHolderAddress
    },
    model: {
      value: (_vm.holderAddress),
      callback: function($$v) {
        _vm.holderAddress = $$v
      },
      expression: "holderAddress"
    }
  }), _vm._v(" "), _c('cell', {
    staticClass: "occupation holderOccupationName",
    attrs: {
      "title": "职业类别",
      "is-link": "",
      "primary": "content"
    }
  }, [_c('span', {
    ref: "occupation",
    staticClass: "selected-occupation",
    staticStyle: {
      "margin-left": "3px"
    },
    attrs: {
      "code": _vm.occupationCode
    }
  }, [_vm._v(_vm._s(_vm.occupationName))])])], 1)], 1)]), _vm._v(" "), _c('m-column', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "title": "其他信息"
    }
  }, [_c('div', {
    slot: "body"
  }, [_c('group', {
    attrs: {
      "gutter": "0"
    }
  }, [_c('cell', {
    attrs: {
      "title": "保障额度"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insuranceAmountsByIDNumber
    },
    model: {
      value: (_vm.insuranceAmount),
      callback: function($$v) {
        _vm.insuranceAmount = $$v
      },
      expression: "insuranceAmount"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "交费期间"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.paymentPeriodsByIDNumber
    },
    on: {
      "change": _vm.changePaymentPeriod
    },
    model: {
      value: (_vm.paymentPeriod),
      callback: function($$v) {
        _vm.paymentPeriod = $$v
      },
      expression: "paymentPeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "id": "when-wrap",
      "title": "保险期间",
      "primary": "content"
    }
  }, [_c('m-candidate', {
    attrs: {
      "list": _vm.insurancePeriods
    },
    on: {
      "change": _vm.changeInsurancePeriod
    },
    model: {
      value: (_vm.orderInsurancePeriod),
      callback: function($$v) {
        _vm.orderInsurancePeriod = $$v
      },
      expression: "orderInsurancePeriod"
    }
  })], 1), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "受益人",
      "value": "法定"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('tabbar', {
    slot: "bottom"
  }, [_c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('p', [_vm._v("价格："), (_vm.paymentShowNull === false) ? _c('label', {
    staticClass: "mark"
  }, [_c('span', {
    staticClass: "payment"
  }, [_vm._v("暂无")])]) : _c('label', {
    staticClass: "mark"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "payment"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(".00/年"), (typeof _vm.number === 'string') ? _c('span', [_vm._v(" 起")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.submitOrder
    }
  }, [_c('span', [_vm._v("提交订单")])])])]), _vm._v(" "), _c('m-login', {
    attrs: {
      "showLogin": _vm.showLogin
    },
    on: {
      "close": _vm.closeLogin
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61b7a4e9"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form.vue
// module id = 656
// module chunks = 1